export default class ItemService {
  constructor($http) {
    this.$http = $http;
  }

  get_dialog_data() {
    return this.$http.get('/admin/marketplace/items/get_dialog_data');
  }

  get_stock_types() {
    return [
			{title: 'Reels', is_reels: true},
			{title: 'Sheets', is_reels: false},
    ];
  }

  save(item) {
    return this.$http.post(
			'/admin/marketplace/items/save_item',
			{item: item, authenticity_token: window.token}
		);
  }

  mass_save(item, items) {
    return this.$http.post(
			'/admin/marketplace/items/save_items',
			{item: item, items: items, authenticity_token: window.token}
		);
  }
}

ItemService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/item.service.js